<template>
<div>
  <div class="columns">
    <div class="column">
      <h3 class="title is-4">{{ attributeType.title }}</h3>
      <p>{{ attributeType.description }}</p>
    </div>
    <div class="column">
      <div class="tags">
        <span class="tag" :class="{
          'is-info': attributeType.scrapes_on_client,
          'is-warning': !attributeType.scrapes_on_client,
        }">
          {{ attributeType.scrapes_on_client ? 'Scrapes Client Side' : 'Scrapes From Backend' }}
        </span>
        <span class="tag" :class="{
          'is-success': attributeType.published,
          'is-danger': !attributeType.published,
        }">
          {{ attributeType.published ? 'Published' : 'Not Published' }}
        </span>
      </div>
    </div>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ])
  }

}
</script>